import { styled } from '@mui/material/styles';
import { IconButton, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const DialogContentWrapper = styled('div')({
  padding: '20px',
  backgroundColor: 'white',
  width: '680px',
  color: 'black'
});

export const CloseDialogButton = styled((props: any) =>
  <IconButton aria-label="close" sx={{ position: 'absolute', right: 8, top: 8 }} {...props}>
    <CloseIcon />
  </IconButton>
)(() => ({}));

export const UserName = styled('div')({
  fontSize: '16px',
  cursor: 'default',
});
